import {Component, ElementRef, Inject, Input, OnInit, ViewChild} from '@angular/core';
import {environment} from "../../../environments/environment";

@Component({
  selector: 'lib-wso2form',
  templateUrl: './wso2form.component.html',
  styleUrls: ['./wso2form.component.css']
})
export class Wso2formComponent implements OnInit {
  @ViewChild('formWso2') formWso2: ElementRef;
  @Input() ERROR_URL: string = environment.homeUrl + '/login?error=error';
  @Input() SAML2: string = 'https://www.monex.com.mx/api/iam/samlsso';
  @Input() usernameWso2: string = '';
  @Input() passwordWso2: string = '';
  @Input() samlRequest:string = '';

  constructor() {  }

  ngOnInit(): void {
  }

  @Input() submit(){
    this.formWso2.nativeElement.submit();
  }

}
